
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/how-daymade-celebrates-international-womens-day-2023",
      function () {
        return require("private-next-pages/blog/how-daymade-celebrates-international-womens-day-2023.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/how-daymade-celebrates-international-womens-day-2023"])
      });
    }
  